import { useState, useEffect, useCallback } from 'react';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import { useSelector } from 'react-redux';

const PAGE_SIZE = 5;

function useStandaloneCartsListPagination() {
      const [carts, setCarts] = useState([]);
      const [lastVisible, setLastVisible] = useState(null);
      const [loading, setLoading] = useState(false);
      const [hasMore, setHasMore] = useState(true);

      const { activeShopId } = useSelector((state) => state.shops);

      const fetchCarts = useCallback(async (loadMore = false, lastDoc = null) => {
            if (!activeShopId) return;

            setLoading(true);
            try {
                  let query = firebase.firestore()
                        .collection('shops')
                        .doc(activeShopId)
                        .collection('carts')
                        .where('cartType', '==', 'standaloneCart')
                        .orderBy('createdAt', 'desc')
                        .limit(PAGE_SIZE);

                  if (loadMore && lastDoc) {
                        query = query.startAfter(lastDoc);
                  }

                  const snapshot = await query.get();
                  if (!snapshot.empty) {
                        const newCarts = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

                        setCarts(prev => loadMore ? [...prev, ...newCarts] : newCarts);
                        setLastVisible(snapshot.docs[snapshot.docs.length - 1]);
                        setHasMore(snapshot.docs.length === PAGE_SIZE);
                  } else {
                        if (!loadMore) setCarts([]);
                        setHasMore(false);
                  }
            } catch (error) {
                  console.error('Error fetching carts:', error);
            }
            setLoading(false);
      }, [activeShopId]);

      // initial load
      useEffect(() => {
            setCarts([]);
            setLastVisible(null);
            setHasMore(true);
            fetchCarts(false, null);
      }, [activeShopId, fetchCarts]);

      const loadMore = () => {
            if (hasMore && !loading) {
                  fetchCarts(true, lastVisible);
            }
      };

      // reload carts from scratch (used after deletion)
      const refetch = useCallback(async () => {
            setCarts([]);
            setLastVisible(null);
            setHasMore(true);
            await fetchCarts(false, null);
      }, [fetchCarts]);

      return { carts, loading, hasMore, loadMore, refetch };
}

export default useStandaloneCartsListPagination;
